import React, { useEffect, useState } from "react";

import {
  Alert,
  AlertDescription,
  AlertIcon,
  AlertTitle,
  useToast,
} from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import { UserAuth } from "../auth/AuthContext";

export const PrivateRoute = ({ children }) => {
  const authToken = document.cookie
    .split("; ")
    .find((row) => row.startsWith("authToken="))
    ?.split("=")[1];
  const { user } = UserAuth();
  const navigate = useNavigate();
  const toast = useToast();

  if (!authToken) {
    navigate("/login", { replace: true });
    toast({
      title: "Login necessário",
      description: "Você precisa fazer o login primeiro.",
      status: "error",
      isClosable: true,
    });
    return null; // retorna null para que o conteúdo da rota privada não seja renderizado
  } else if (!user) {
    navigate("/login", { replace: true });
    toast({
      title: "Acesso não autorizado",
      description: "Você precisa fazer o login primeiro.",
      status: "error",
      isClosable: true,
    });
    return null; // retorna null para que o conteúdo da rota privada não seja renderizado
  }

  return children; // retorna o conteúdo da rota privada
};
export const AdminRoute = ({ children }) => {
  const { user } = UserAuth();
  const navigate = useNavigate();
  const [timeLeft, setTimeLeft] = useState(5);

  useEffect(() => {
    if (user.email !== "israelvcb@hotmail.com") {
      const intervalId = setInterval(() => {
        setTimeLeft((timeLeft) => {
          if (timeLeft === 0) {
            navigate(-1);
            clearInterval(intervalId);
            return 0;
          }
          return timeLeft - 1;
        });
      }, 1000);
      return () => clearInterval(intervalId);
    }
  }, [user.email, navigate]);

  if (user.email === "israelvcb@hotmail.com") {
    return children;
  }
  return (
    <>
      <Alert
        status="error"
        variant="solid"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        textAlign="center"
        height="100%"
        border="lg"
        borderRadius={10}
      >
        <AlertIcon boxSize="80px" mr={0} />
        <AlertTitle mt={4} mb={1} fontSize="lg">
          Permissão Insuficiente!
        </AlertTitle>
        <AlertDescription maxWidth="sm">
          Você não pode criar novos usuários, consulte o seu administrador!
        </AlertDescription>
        <AlertDescription>Voltando em: {timeLeft} segundos</AlertDescription>
      </Alert>
    </>
  );
};
